// extracted by mini-css-extract-plugin
export default {"textBox":"ep6nbL5y7OBd1WhkcnLA"};